export const URL_REGEXP =
  // eslint-disable-next-line max-len
  /(https?:\/\/|www\.)[-a-zA-Z0-9@:%._\+~#=]{1,256}\.(xn--)?[a-z0-9-]{2,20}\b([-a-zA-Z0-9@:%_\+\[\],.~#?&\/=]*[-a-zA-Z0-9@:%_\+\]~#?&\/=])*/gi;
export const SPACE_REGEXP = /(\s+)/;
export const HTTPS_REGEXP = /(https?:\/\/)/gi;
export const SOUNDCLOUD_URL_REGEX =
  /https:\/\/(on\.soundcloud\.com|soundcloud\.com)\/.*/gm;
